type Props = {
  size?: number;
  color?: string;
  className?: string;
};

export const InputIcon = ({
  size = 16,
  color = "currentColor",
  className,
}: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.94238 23.8567V17.9187H5.31756V21.4815H24.319V7.23046H5.31756V10.7932H2.94238V4.85529H26.6941V23.8567H2.94238ZM14.2245 19.7001L12.5618 17.9781L15.0261 15.5436H2.94238V13.1684H15.0261L12.5618 10.7338L14.2245 9.01184L19.5686 14.356L14.2245 19.7001Z"
        fill={color}
      />
    </svg>
  );
};
